export default __webpack_public_path__ + "static/hero-video-d70971e5ce0ad6ee1d91c5829664355d.mp4";